import { urlFor } from '@/sanity/lib/image';

export const resolveIconUrl = (icon: any): string | null => {
  if (!icon) return null;
  if (icon?._type === 'image' && icon?.asset?._ref) {
    return urlFor(icon).width(50).height(45).fit('max').quality(90).url();
  }
  if (icon?.asset?.url) return icon.asset.url;
  if (icon?.url) return icon.url;
  return null;
};
